import axios from "axios";
import { getApiBase } from "../apiBase";

/**
 * Email technicians for networking installations not yet notified; marks rows as sent.
 */
export async function notifyNetworkingInstallationEmails({ projectId, getAuthHeaders, apiUrl }) {
  const base = apiUrl || getApiBase();
  const { data } = await axios.post(
    `${base}/projects/${projectId}/networking-installation-notify`,
    {},
    { headers: getAuthHeaders() }
  );
  return data;
}
